import React from "react";
import Banner from "../../pages/banner";
import GlobalSection from "../GlobalSection";

const LivingRoomSection = () => {

  return (

    <>

      <Banner
        title="Living Room Furniture"
        subtitle="Premium Comfort & Modern Living Designs"
        height="150px"
      />

      <GlobalSection

        sectionTitle="Living Room Furniture"

        sectionSubtitle="Premium Comfort & Modern Living Designs"

        sectionCategories={[

          {
            title: "Luxury Sofas",
            img: "/images/sofa/sofa1.png",
          },

          {
            title: "Coffee Tables",
            img: "/images/sofa/sofa2.png",
          },

          {
            title: "TV Units",
            img: "/images/sofa/sofa3.png",
          },

          {
            title: "Accent Chairs",
            img: "/images/sofa/sofa4.png",
          },

          {
            title: "Luxury Sofas",
            img: "/images/sofa/sofa1.png",
          },

          {
            title: "Coffee Tables",
            img: "/images/sofa/sofa2.png",
          },

          {
            title: "TV Units",
            img: "/images/sofa/sofa3.png",
          },

          {
            title: "Accent Chairs",
            img: "/images/sofa/sofa4.png",
          },

        ]}

      />

    </>

  );
};

export default LivingRoomSection;